import { TestimonialsSection, CTASection } from '@/components/sections'

export const StoriesPage = () => (
  <main>
    <TestimonialsSection />
    <CTASection />
  </main>
)
